"use strict";

$(document).ready(function () {
  if ($('.hero_slider').length > 0) {
    var slider_interval = $('.hero_slider .swiper-container').attr('data-interval');
    var slider_wrap = $('.hero_slider .swiper-container').attr('data-wrap');
    var slider_pause = $('.hero_slider .swiper-container').attr('data-pause');
    var heroSlider = hero_slider(slider_interval, slider_wrap);

    if (slider_pause === 'hover') {
      $(".hero_slider .swiper-container").hover(function () {
        heroSlider.autoplay.stop();
      }, function () {
        heroSlider.autoplay.start();
      });
    }
  }

  if ($('.hero_slider .swiper-pagination-bullet').length < 2) {
    $('.hero_slider .pagination-container').addClass('hide');
  }
});

function hero_slider(interval, wrap) {
  var interval = parseInt(interval);
  var swiper = new Swiper('.hero_slider .swiper-container', {
    lazy: true,
    loop: wrap,
    autoplay: {
      delay: interval
    },
    pagination: {
      el: '.hero_slider .swiper-pagination',
      clickable: true
    }
  });
  return swiper;
}